/**
 * Reduce tamaño de la foto antes de subirla (p. ej. iPad: fotos de varios MB).
 * Muchos reverse proxies (nginx) cortan con client_max_body_size; ERR_NETWORK + HTTP 0 suele ser eso.
 */
const DEFAULT_MAX_EDGE = 1920;
const DEFAULT_QUALITY = 0.82;
const MIN_ORIGINAL_BYTES_TO_COMPRESS = 280 * 1024; // fotos de cámara suelen ser mucho mayores

function extensionFromMime() {
	return ".jpg";
}

/**
 * @param {File} file
 * @returns {Promise<File>}
 */
export async function shrinkImageForUpload(file, options = {}) {
	if (!file || typeof file !== "object") return file;

	const maxEdge = options.maxEdge ?? DEFAULT_MAX_EDGE;
	const quality = options.quality ?? DEFAULT_QUALITY;
	const minBytes = options.minBytes ?? MIN_ORIGINAL_BYTES_TO_COMPRESS;

	const type = file.type || "";
	if (!type.startsWith("image/")) return file;

	if (file.size < minBytes && (type === "image/jpeg" || type === "image/pjpeg")) return file;

	return new Promise((resolve) => {
		const url = URL.createObjectURL(file);
		const img = new Image();

		const cleanup = () => URL.revokeObjectURL(url);

		img.onload = () => {
			try {
				let w = img.naturalWidth || img.width;
				let h = img.naturalHeight || img.height;
				if (!w || !h) {
					cleanup();
					resolve(file);
					return;
				}

				const scale = Math.min(1, maxEdge / Math.max(w, h));
				w = Math.round(w * scale);
				h = Math.round(h * scale);

				const canvas = document.createElement("canvas");
				canvas.width = w;
				canvas.height = h;
				const ctx = canvas.getContext("2d");
				if (!ctx) {
					cleanup();
					resolve(file);
					return;
				}

				if (type === "image/jpeg" || type === "image/webp") {
					ctx.fillStyle = "#fff";
					ctx.fillRect(0, 0, w, h);
				}
				ctx.drawImage(img, 0, 0, w, h);

				const outMime = "image/jpeg";
				canvas.toBlob(
					(blob) => {
						cleanup();
						if (!blob || blob.size >= file.size * 0.98) {
							resolve(file);
							return;
						}
						const base =
							(file.name && file.name.replace(/\.[^.]+$/, "")) || "foto-equipo";
						const outName = `${base}${extensionFromMime()}`;
						const outFile = new File([blob], outName, {
							type: outMime,
							lastModified: Date.now(),
						});
						resolve(outFile);
					},
					outMime,
					quality
				);
			} catch (_) {
				cleanup();
				resolve(file);
			}
		};

		img.onerror = () => {
			cleanup();
			resolve(file);
		};

		img.src = url;
	});
}
